import { WhatIsAGithubDigestArticle } from '@/components/what-is-a-github-digest/what-is-a-github-digest-article'
import { Container } from '@/components/container'
import { Footer } from '@/components/footer'
import { Navbar } from '@/components/navbar'
import { Head } from '@inertiajs/react'

const TITLE = 'What Is a GitHub Digest for Your Team'
const DESCRIPTION =
  'A GitHub digest is a daily or weekly summary of commits from selected repositories, posted to Slack and email for an engineering team.'

type Faq = {
  question: string
  answer: string
}

type Props = {
  headline: string
  faqs: Faq[]
}

export default function WhatIsAGithubDigestShow({ headline, faqs }: Props) {
  return (
    <>
      <Head title={TITLE}>
        <meta head-key="description" name="description" content={DESCRIPTION} />
      </Head>
      <div className="flex min-h-screen flex-col">
        <main className="flex-1 overflow-hidden">
          <Container>
            <Navbar />
          </Container>
          <div className="from-background via-feature-subtle/50 to-muted/20 min-h-100vh bg-gradient-to-b">
            <Container className="py-16 md:py-24">
              <WhatIsAGithubDigestArticle headline={headline} faqs={faqs} />
            </Container>
          </div>
        </main>
        <Footer />
      </div>
    </>
  )
}
